import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

//import { normalize, schema, Array } from 'normalizr';

/**
 */
class Auth extends BaseApi{
  static getClassName(){ return 'Auth' }

  /**
   */
  static login(input){
    return app.make("axios").post(`v1/auth/login`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  /**
   */
  static logout(input){
    app.make("axios").defaults.headers.common['Authorization'] = `Bearer ${store.get("token")}`

    return app.make("axios").post(`v1/auth/logout`,{})
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }
}
export default Auth



// WEBPACK FOOTER //
// ./src/api/Auth.js